import CciArticleList from 'components/cciarticlelist/CciArticleList.vue'
import CciArticle from 'components/cciarticle/CciArticle.vue'
// import CciImageGalleryModal from 'components/cciimagegallerymodal/CciImageGalleryModal.vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  mounted () {
    this.applySettings(this.settings)
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
      showImageGalleryInArticle: 'getShowImageGalleryInArticle'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        var header = document.getElementsByClassName('left-holder')[0]
        header.style.backgroundColor = settings.articleListBackgroundColor
      }
    }
  },
  components: {
    CciArticleList,
    CciArticle,
    // CciImageGalleryModal
  }
}
